// extracted by mini-css-extract-plugin
export default {"footer":"AddEventToNylasModal_footer__7Dfue","calendarName":"AddEventToNylasModal_calendarName__0WNeh"};